import { AppBar, Box, Stack, Toolbar } from "@mui/material";
import React, { useEffect, useState } from "react";
import Profile from "./Profile";
import Notifications from "./Notification/Notifications";
import Logo from "../../assets/JOptimanlogo.png";
import httpClient from "../../_util/api";
import ToggleSidebar from "./ToogleSidebar";
import DuplicateNotification from "./Notification/DuplicateNotification";

const Header = () => {
  // const isAdmin = JSON.parse(localStorage.getItem('isAdmin'))
  // const [notifications, setNotifications] = useState([
  //     {
  //         id: "",
  //         message: "",
  //         status: 0,
  //         policyNumber: "",
  //         unRead: true,
  //     }
  // ]);

  // const [noOfUnReadNotifications, setNoOfUnReadNotifications] = useState(0)

  // const getNotifications = async () => {
  //     if (isAdmin) {
  //         const res = await httpClient.get('/notifications/getAllNotifications_AdminView').catch((error) => { console.log(error) })
  //         console.log("res", res);
  //         if (res?.status === 200) {
  //             console.log("res", res.data);
  //             setNotifications(res.data.notifications.map(notifications => ({
  //                 id: notifications._id,
  //                 message: notifications.message,
  //                 policyNumber: notifications.policyNumber,
  //                 status: notifications.status,
  //                 unRead: notifications.unRead,
  //             })))
  //             setNoOfUnReadNotifications(res.data.noOfUnReadNotification)
  //         }
  //     }
  //     else {
  //         const res = await httpClient.get(`/notifications/getAllNotifications_AgentView/${agentCode}`).catch((error) => { console.log(error) })
  //         if (res?.status === 200) {
  //           setNotifications(res.data.notifications.map(notifications => ({
  //             id: notifications._id,
  //             message: notifications.message,
  //             policyNumber: notifications.policyNumber,
  //             status: notifications.status,
  //             unRead:notifications.unRead
  //           })))
  //         }
  //       }
  // }

  // useEffect(() => {
  //     getNotifications()
  // }, [])

  return (
    <div>
      <AppBar
        className="crm-app-bar"
        sx={{
          backgroundColor: "#0c0544",
          paddingTop: "5px",
          paddingBottom: "5px",
        }}
      >
        <Toolbar sx={{ minHeight: "64px !important", px: { xs: 1, sm: 2 } }}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            sx={{ width: "100%", minWidth: 0, gap: 1 }}
          >
            <Box
              sx={{
                width: { xs: 120, sm: 168 },
                flexShrink: 0,
                pl: "4px",
              }}
            >
              <img
                src={Logo}
                alt="Joptiman Logo"
                style={{ width: "100%", height: "auto", display: "block" }}
              />
            </Box>

            
   <div style={{ display: 'flex', justifyContent: 'flex-end', width: "max-content", gap: '10px', alignItems: 'center', paddingRight: '10px', }}>
   <Box
              sx={{
                flex: 1,
                display: "flex",
                justifyContent: "center",
                minWidth: 0,
              }}
            >
              <DuplicateNotification />
            </Box>
            <Profile />
            <Box
              sx={{
                justifyContent: "flex-start",
                width: 'max-content',
              }}
            >
              <p>Agents Support </p>
              <a href="tel:+18884917757" style={{ color: "#f08613", textDecoration: 'none', fontSize: '14px', fontWeight: 'bold', }}>+1 (888) 491-7757</a>
              </Box>
   </div>
           
          </Stack>
        </Toolbar>
      </AppBar>
    </div>
  );
};
export default Header;
